module.exports = __webpack_public_path__ + "img/当归.bf718aa1.jpg";